
export default {
  props: {
    options: {type: Array, default: () => []}
  },
  emits: ['save'],
  data(){
    return {
      visible: false,
    }
  },
  methods: {
    onOptionClick(hide, cb){
      hide()
      if (typeof cb === 'function') {
        cb()
      }
    }
  }
}
